import { forwardRef } from 'react';
import MarkdownBase from './MarkdownBase';
import {
  BlockTypeSelect,
  BoldItalicUnderlineToggles,
  CodeToggle,
  CreateLink,
  diffSourcePlugin,
  DiffSourceToggleWrapper,
  imagePlugin,
  InsertImage,
  InsertThematicBreak,
  linkDialogPlugin,
  ListsToggle,
  markdownShortcutPlugin,
  MDXEditorMethods,
  Separator,
  StrikeThroughSupSubToggles,
  tablePlugin,
  toolbarPlugin,
  UndoRedo,
} from '@mdxeditor/editor';
import { MarkdownEditableProps } from './types';

const MarkdownEditable = forwardRef<MDXEditorMethods, MarkdownEditableProps>(
  (props, ref) => {
    return (
      <MarkdownBase
        ref={ref}
        {...props}
        plugins={[
          linkDialogPlugin(),
          imagePlugin(),
          tablePlugin(),
          markdownShortcutPlugin(),
          diffSourcePlugin(),
          toolbarPlugin({
            toolbarContents: () => (
              <DiffSourceToggleWrapper>
                <UndoRedo />
                <Separator />
                <BlockTypeSelect />
                <Separator />
                <BoldItalicUnderlineToggles />
                <CodeToggle />
                <Separator />
                <StrikeThroughSupSubToggles />
                <Separator />
                <CreateLink />
                <InsertImage />
                <Separator />
                <ListsToggle />
                <InsertThematicBreak />
              </DiffSourceToggleWrapper>
            ),
          }),
        ]}
      />
    );
  },
);

MarkdownEditable.displayName = 'MarkdownEditable';
export default MarkdownEditable;
